import { PriceRangeFilter } from './components/priceRangeFilter/PriceRangeFilter';
import { CheckboxFilter } from './components/checkboxFilter/CheckboxFilter';
import { BrokerFilter } from './components/brokerFilter/BrokerFilter';
import { FilterGroup } from './components/filterGroup/FilterGroup';
import { PropertyTypeFilter } from './components/propertyTypeFilter/PropertyTypeFilter';
import { VariousFilters } from './components/variousFilters/VariousFilters';
import { Filters as FiltersType } from '@/domain';
import { useUnleash } from '@/hooks/unleash';

export type FilterProps = {
    filters: FiltersType;
    onFilterChanged: (filters: FiltersType) => void;
};
type FilterAndDataProps = FilterProps & {
    filterData: Record<string, unknown>;
};

const mapItems = (items: string[] = []): string[] => (Array.isArray(items) ? items : [items]);

export const Filters = ({ filterData, filters, onFilterChanged }: FilterAndDataProps) => {
    const unleash = useUnleash();
    return (
        <div data-testid="filters" role="region" aria-label="Filtre">
            <FilterGroup title="Utleier">
                <BrokerFilter filters={filters} onFilterChanged={onFilterChanged} />
            </FilterGroup>
            <FilterGroup title={'Pris per natt'} data-testid="FilterGroup-pris">
                <PriceRangeFilter filters={filters} onFilterChanged={onFilterChanged} />
            </FilterGroup>
            <FilterGroup title="Boligtype">
                <PropertyTypeFilter propertyTypes={mapItems(filters.property_types)} onFilterChanged={onFilterChanged} />
            </FilterGroup>
            <FilterGroup title="Fasiliteter">
                <CheckboxFilter
                    onFilterChanged={onFilterChanged}
                    filterData={filterData.facilities as string[]}
                    filterValues={mapItems(filters.facilities)}
                    filterType="facilities"
                />
            </FilterGroup>
            <FilterGroup title="I nærheten av">
                <CheckboxFilter
                    onFilterChanged={onFilterChanged}
                    filterData={filterData.pois_nearby as string[]}
                    filterValues={mapItems(filters.pois_nearby)}
                    filterType="pois_nearby"
                />
            </FilterGroup>
            {!unleash?.tjvrRelease && (
                <FilterGroup title="Vis kun annonser med">
                    <VariousFilters filters={filters} onFilterChanged={onFilterChanged} />
                </FilterGroup>
            )}
        </div>
    );
};
